import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './AuthPage.scss';

// Asset imports
import accoladeLogo from '../../assets/Logo-Accolade-light-2.png';
import backgroundImage from '../../assets/backgroundImages/login-bg-image-2.jpg';
import brandLogos from '../../assets/Tri-Brand_footer-2.png';
import languageIcon from '../../assets/icons/language-icon-white.svg';
import { LoginForm } from '../../components/LoginForm/LoginForm';
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm/ForgotPasswordForm';
import { SlidePanel } from '../../components/SlidePanel/SlidePanel';


const AuthPage: React.FC = () => {
  const { t, i18n } = useTranslation('auth');
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  useEffect(() => {
    const state = location.state as { showForgotPassword?: boolean };
    if (state?.showForgotPassword) {
      setIsForgotPasswordOpen(true);
      // Clear the state so it doesn't reopen on refresh
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  const handleRegistrationClick = () => {
    navigate('/carousel-presentation');
  };

  return (
    <div className="authPageContainer" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="contentWrapper">
        <header className="header-auth">
          <button
            className="language-toggle"
            onClick={toggleLanguage}
            aria-label={t('nav.changeLanguage')}
          >
            <img src={languageIcon} alt="" />
            <span>{i18n.language.toUpperCase()}</span>
          </button>
          <p className="welcomeText">{t('authPage.welcomeTo')}</p>
          <img src={accoladeLogo} alt={t('altText.accoladeLogo')} className="accoladeLogo" />
        </header>
        <main className="mainContent">
          <h1 className="headline">
            {t('authPage.headline1')}<br />
            {t('authPage.headline2')}
          </h1>
          <div className="buttonGroup">
            <button 
              className="button registerButton"
              onClick={handleRegistrationClick}
            >
              {t('authPage.registrationButton')}
            </button>
            <button 
              className={`button loginButton ${isLoginOpen ? 'active' : ''}`}
              onClick={() => setIsLoginOpen(true)}
            >
              {t('authPage.loginButton')}
            </button>
          </div>
          <p className="tagline">{t('authPage.tagline')}</p>
        </main>
        <footer className="footer-auth">
          <img src={brandLogos} alt={t('altText.brandLogos')} className="brandLogos" />
          <Link to="/guest-contact" className="contact-link">
            {t('authPage.needHelp')} <span className="underline-hover">{t('authPage.contactUs')}</span>
          </Link>
        </footer>
      </div>

      <SlidePanel 
        isOpen={isLoginOpen} 
        onClose={() => setIsLoginOpen(false)}
        position="right"
      >
        <LoginForm 
          onForgotPassword={() => {
            setIsForgotPasswordOpen(true);
            setIsLoginOpen(false);
          }}
        />
      </SlidePanel>

      <SlidePanel 
        isOpen={isForgotPasswordOpen} 
        onClose={() => setIsForgotPasswordOpen(false)}
        position="right"
      >
        <ForgotPasswordForm 
          onBackToLogin={() => {
            setIsForgotPasswordOpen(false);
            setIsLoginOpen(true);
          }}
        />
      </SlidePanel>
    </div>
  );
};

export default AuthPage;
